import React, { useState } from "react"
import { api } from "../../lib/api"
import type { Me } from "../../types"
import { Botao, Card } from "../ui"

export default function Configuracoes({ me, recarregar }: { me: Me; recarregar: () => Promise<void> }) {
  const [nome, setNome] = useState(me.usuario.nome ?? "")
  const [dataDaProva, setDataDaProva] = useState(me.usuario.data_da_prova ?? "")
  const [salvando, setSalvando] = useState(false)
  const [salvo, setSalvo] = useState(false)

  async function salvar(evento: React.FormEvent) {
    evento.preventDefault()
    setSalvando(true)
    setSalvo(false)
    await api.patch("/me", { usuario: { nome, data_da_prova: dataDaProva || null } })
    await recarregar()
    setSalvando(false)
    setSalvo(true)
  }

  return (
    <div className="space-y-6">
      <h1 className="text-xl font-bold text-navy-900">Sua conta</h1>

      <Card>
        <form onSubmit={salvar} className="space-y-4">
          <div>
            <label htmlFor="nome" className="block text-sm font-semibold text-navy-900">
              Nome
            </label>
            <input
              id="nome"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              className="mt-1 w-full rounded-xl border border-navy-200 px-3 py-2.5 text-sm"
            />
          </div>
          <div>
            <label htmlFor="data_da_prova" className="block text-sm font-semibold text-navy-900">
              Data da prova
            </label>
            <input
              id="data_da_prova"
              type="date"
              value={dataDaProva}
              onChange={(e) => setDataDaProva(e.target.value)}
              className="mt-1 rounded-xl border border-navy-200 px-3 py-2.5 text-sm"
            />
            <p className="mt-1 text-xs text-slate-500">
              É ela que monta o seu plano de estudo no painel. Deixe em branco para não receber a tarefa do dia.
            </p>
          </div>
          <div>
            <span className="block text-sm font-semibold text-navy-900">E-mail</span>
            <p className="mt-1 text-sm text-slate-600">{me.usuario.email}</p>
          </div>
          <div className="flex items-center gap-3">
            <Botao type="submit" disabled={salvando}>
              {salvando ? "Salvando…" : "Salvar"}
            </Botao>
            {salvo && <span className="text-sm text-emerald-700">Salvo.</span>}
          </div>
        </form>
      </Card>

      {/* Sair e o atalho do admin moram no menu "Conta" do cabeçalho, que é
          onde as pessoas procuram — repeti-los aqui só duplicava a manutenção. */}
    </div>
  )
}
